/**
 * Ceramixa style — brand wordmark.
 * Renders the official company logo (gold geometric pattern + wordmark).
 * Uses /ceramixa-logo.png (transparent PNG, served from public/).
 */
export default function BrandMark({ size = "md" }) {
    const heights = { sm: "h-12", md: "h-16", lg: "h-20" };
    return (
        <div className="flex items-center justify-center w-full">
            <img
                src="/ceramixa-logo.png"
                alt="Ceramixa style s.r.o. — Obklady, Dlažby, Terasy, Bazény"
                className={`${heights[size] || heights.md} w-auto select-none`}
                draggable={false}
            />
        </div>
    );
}

/** Used on white-background pages (login/register/accept-invite). Same logo. */
export function BrandMarkDark({ size = "lg" }) {
    const heights = { sm: "h-14", md: "h-20", lg: "h-24" };
    return (
        <div className="flex items-center">
            <img
                src="/ceramixa-logo.png"
                alt="Ceramixa style s.r.o."
                className={`${heights[size] || heights.lg} w-auto select-none`}
                draggable={false}
            />
        </div>
    );
}
